import { currencyList, chargesData } from "./StaticData"
import { TableEdit, TableSelect, TableLabel, AgInput, AgSelect, TableComboInput } from "./components/AgComponents"
import { useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import Api from "./state/Api"
import {
    quoteDataRec, chargesStore1, cargoStore, configStore
} from './state/CommonState'
import ReactDOMServer from 'react-dom/server'
import Utils from "./util/Utils"
import { chargesValidationStore } from "./state/validation-stores"

export default function ChargesComp1() {
    const [grandTotal, setGrandTotal] = useState(0.0)
    useSnapshot(cargoStore)
    console.log('ChargesComp rendering')
    const data = chargesData[quoteDataRec.shipmentType]
    let [space, setSpace] = useState('')

    let imChargesStore = useSnapshot(chargesStore1)
    let a = imChargesStore.newRec
    let b = imChargesStore.editRec

    useEffect(() => {
        console.log('ChargesComp1 useEffect')
    }, [])
    const deleteRec = (id) => {
        if (id <= imChargesStore.initialLength) return
        const index = chargesStore1.list.findIndex(e => e.id === id)
        let records = chargesStore1.list
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        chargesStore1.list = records
        //console.log('AFTER DELETE=', JSON.stringify(chargesStore1.cargoList))
    }
    const Th2 = (props) => <th rowSpan="2" {...props} style={{ paddingTop: '1.5rem' }}>{props.children}</th>
    const Ts = ({ i, name, dataList, ...otherProps }) => <TableSelect
        record={chargesStore1.list[i]} name={name} dataList={dataList} isValid={chargesValidationStore.isValidCharge(name, i)} {...otherProps} />
    const Te = ({ i, name }) => {
        const e = chargesStore1.list[i]
        if (name === 'chargeDescription' && i < chargesStore1.initialLength)
            return <TableLabel record={chargesStore1.list[i]} name={name} />
        return (
            <TableComboInput record={chargesStore1.list[i]} name={name} />
        )
    }
    const Tn = ({ i, name, ...otherProps }) => {
        const e = chargesStore1.list[i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <input disabled='true' style={{ width: '3rem', backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={chargesStore1.list[i]} name={name} type='number' isValid={chargesValidationStore.isValidCharge(name, i)} {...otherProps} />
        )
    }
    const Tsn = ({ name, dataList }) => <TableSelect
        record={chargesStore1.newRec} name={name} dataList={dataList} />
    const Ten = ({ name }) => <TableEdit record={chargesStore1.newRec} name={name} />
    const Tnn = ({ name }) => <TableEdit record={chargesStore1.newRec} name={name} type='numeric' />
    const ifNotFCL = () => quoteDataRec.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        chargesStore1.list.map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            finalTotal += e.total * erate
        })
        return finalTotal;
    }

    return (
        <>
            <hr />
            <div className="table-container" onClick={(e) => e.stopPropagation()}>
                <table className="table is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                        <tr>
                            <th colSpan='2'>
                                <button className="button is-small is-rounded" style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff" }} onClick={() => {
                                    // chargesStore1.list.map((e, i) => {
                                    //     let erate = configStore.getExchangeRateinr(e)
                                    //     if (!erate || erate === 0) erate = 1.0
                                    //     erate = 1.0 // nullifying the rate.
                                    //     if (!e.perCBM) e.perCBM = 0
                                    //     if (!e.perTon) e.perTon = 0
                                    //     if (!e.minimum) e.minimum = 0
                                    //     if (!e.maximum) e.maximum = 0
                                    //     if (!e.perShipment) e.perShipment = 0
                                    //     let tots = cargoStore.totals
                                    //     let val = Number(e.perCBM) * Number(tots.totTotalVolume)
                                    //     console.log('1', val, e.perCBM, Number(e.perCBM), Number(tots.totTotalVolume))
                                    //     let temp = Number(e.perTon) * Number(tots.totTotalWeight) / 1000
                                    //     if (temp > val) val = temp
                                    //     temp = Number(e.minimum)
                                    //     if (temp > val) val = temp
                                    //     temp = Number(e.maximum)
                                    //     if (temp > 0 && temp < val) val = temp

                                    //     console.log(val)
                                    //     e.total = Utils.R(
                                    //         (Number(val) + Number(e.perShipment)) 
                                    //         * erate)
                                    // })
                                    chargesStore1.calculateChargesTotals()
                                    setSpace(space === '' ? ' ' : '')
                                }}>Click to Re-Calculate Charges</button>
                            </th>
                            <th colSpan='12'>
                                <h3 className="is-size-5 ">Charges{space}</h3>
                            </th>
                        </tr>
                        {ifNotFCL() ?
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th colSpan='4' className="has-text-centered" style={{ backgroundColor: '#efefef' }}>Per Unit</th>
                                <th></th>
                                <th ></th>
                                <th></th>
                            </tr> : <></>
                        }
                        <tr>
                            <th style={{ width: '5rem' }}>ID</th>
                            <th style={{ width: '20rem' }}>Charge Description</th>
                            <th>Currency</th>
                            <th>Per CBM</th>
                            <th>Per Ton</th>
                            <th>Minimum</th>
                            <th>Maximum</th>
                            <th>Per shipment</th>
                            <th style={{ textAlign: 'right' }}>Total</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            chargesStore1.list.map((e, i) => {
                                {
                                    return <tr key={e.id}>
                                        <td >{e.id}</td>
                                        <td><Te i={i} name='chargeDescription' /></td>
                                        <td><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                        <td><Tn i={i} name='perCBM' /></td>
                                        <td><Tn i={i} name='perTon' /></td>
                                        <td><Tn i={i} name='minimum' /></td>
                                        <td><Tn i={i} name='maximum' /></td>
                                        <td><Tn i={i} name='perShipment' /></td>
                                        <td style={{ textAlign: 'right' }}>{
                                            (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                        }</td>
                                        <td>

                                            <div className="field has-addons">
                                                {
                                                    (i >= chargesStore1.initialLength) && (<p className="control">
                                                        <button className="button is-danger is-inverted"
                                                            onClick={() => {
                                                                deleteRec(e.id)
                                                                setSpace(space === '' ? ' ' : '')
                                                            }}>
                                                            <span className="icon">
                                                                <i className="fas fa-trash"></i>
                                                            </span>
                                                        </button>
                                                    </p>)}
                                                {
                                                    i == chargesStore1.list.length - 1 && (<p className="control">
                                                        <button className="button is-success is-inverted"
                                                            onClick={() => {
                                                                let obj = chargesStore1.newRec
                                                                obj = { ...obj }
                                                                chargesStore1.list.push({ ...obj, id: chargesStore1.list.length + 1 })
                                                                setSpace(space === '' ? ' ' : '')
                                                            }}>
                                                            <span className="icon is-small">
                                                                <i className="fas fa-plus"></i>
                                                            </span>
                                                        </button>
                                                    </p>)
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                            }
                            )
                        }
                        {/* <tr style={{ border: '2px solid grey' }}>
                            <td ></td>
                            <td><Ten name='chargeDescription'></Ten></td>
                            <td><Tsn name='currency' dataList={configStore.getCurrencyList()} /></td>
                            <td><Tnn name='perCBM' /></td>
                            <td><Tnn name='perTon' /></td>
                            <td><Tnn name='minimum' /></td>
                            <td><Tnn name='maximum' /></td>
                            <td><Tnn name='perShipment' /></td>
                            <td><Tnn name='total' /></td>
                            <td>
                                <div className="field has-addons">
                                    <p className="control">
                                        <button className="button is-success is-inverted"
                                            onClick={() => {
                                                let obj = chargesStore1.newRec
                                                obj = { ...obj }
                                                chargesStore1.list.push({ ...obj, id: chargesStore1.list.length + 1 })
                                                setSpace(space === '' ? ' ' : '')
                                            }}>
                                            <span className="icon is-small">
                                                <i className="fas fa-plus"></i>
                                            </span>
                                        </button>
                                    </p>
                                </div>
                            </td>
                        </tr> */}
                        <tr>
                            <td colSpan={8}></td>
                            <td><strong>{Utils.N(calculateFinalTotal())}</strong></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}
